module.exports = __webpack_public_path__ + "img/clip-n-climb.5c39ccd4.webp";